export default __webpack_public_path__ + "static/media/sgd.13b6fbc4.png";